// src/components/pages/integration/Integration.tsx
import React, { useState } from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import "./Integration.css";

import { IntegrationPageProps } from "../../../models/integrations.model";
import { useIntegrations } from "../../../hooks/useIntegrations";
import { IntegrationLayers } from "./IntegrationsLayers";
import { IntegrationContent } from "./IntegrationsContent";

const IntegrationPage: React.FC<IntegrationPageProps> = ({ offset, isFirstVisit }) => {
	const [activeSection, setActiveSection] = useState("DEFI");
	const { loading, category, categories, setCategory, allIntegrations } = useIntegrations(activeSection);

	return (
		<div
			className="integration-container"
			style={{ top: `${offset * 100}vh` }}
		>
			<IntegrationLayers offset={offset} />
			<ParallaxLayer
				offset={0}
				speed={0}
				style={{ zIndex: 20, pointerEvents: "auto" }}
			>
				<IntegrationContent
					isFirstVisit={isFirstVisit}
					categories={categories ?? []}
					category={category}
					setCategory={setCategory}
					activeSection={activeSection}
					setActiveSection={setActiveSection}
					loading={loading}
					items={allIntegrations ?? []}
				/>
			</ParallaxLayer>
		</div>
	);
};

export default IntegrationPage;
